import {Component, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'welcome-not-found',
    templateUrl: 'welcome-not-found.component.html'
})
export class WelcomeNotFoundComponent {
    constructor() {
    }
}